module.exports = function() {
  return new Worker(__webpack_public_path__ + "ab58248baa768f688b92.worker.js");
};